import { render, staticRenderFns } from "./FriendToggleLocked.vue?vue&type=template&id=1ff93563&"
import script from "./FriendToggleLocked.vue?vue&type=script&lang=js&"
export * from "./FriendToggleLocked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports